import CButton from "components/CButton";
import CDialog from "components/CDialog";

export type OtherEmploymentDialogProps = {
  open: boolean;
  onAccept: () => void;
  onDismiss: () => void;
};

const OtherEmploymentDialog: React.FC<OtherEmploymentDialogProps> = ({
  open,
  onAccept,
  onDismiss,
}) => {
  return (
    <CDialog
      open={open}
      maxWidth="xs"
      title="Do you have any other employment to verify?"
    >
      <CButton
        fullWidth
        variant="contained"
        onClick={onAccept}
        sx={{ textTransform: "inherit", fontSize: 20, marginBottom: 2 }}
      >
        Yes
      </CButton>
      <CButton
        sx={{ textTransform: "inherit", fontSize: 20 }}
        fullWidth
        variant="outlined"
        onClick={onDismiss}
      >
        No
      </CButton>
    </CDialog>
  );
};

export default OtherEmploymentDialog;
